import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import range from 'lodash/range';

import './SliderControls.css';

const SliderControls = memo(
  ({
    currSlide,
    updateCurrSlide,
    onClickLeft,
    onClickRight,
    count,
    sliderButtonClassName,
  }) => {
    return (
      <div
        className={classNames('mobile-controls-container', {
          hidden: count === 1,
        })}
      >
        <button
          type="button"
          onClick={onClickLeft}
          className={classNames(
            'zoom-image-box-arrow',
            'gallery-left-arrow',
            sliderButtonClassName,
            {
              'mobile-controls-hidden': currSlide === 0,
            }
          )}
        >
          <i className="fal fa-angle-left" />
        </button>
        {count > 1 && (
          <div className="dots-wrapper">
            {range(count).map((i) => (
              // eslint-disable-next-line jsx-a11y/control-has-associated-label
              <button
                type="button"
                className={classNames('zoom-image-box-dot', {
                  'zoom-image-box-selected-dot': i === currSlide,
                })}
                key={i}
                onClick={() => updateCurrSlide(i)}
              />
            ))}
          </div>
        )}
        <button
          type="button"
          className={classNames(
            'gallery-right-arrow',
            'zoom-image-box-arrow',
            sliderButtonClassName,
            { 'mobile-controls-hidden': currSlide === count - 1 }
          )}
          onClick={onClickRight}
        >
          <i className="fal fa-angle-right" />
        </button>
      </div>
    );
  }
);

SliderControls.propTypes = {
  updateCurrSlide: PropTypes.func.isRequired,
  currSlide: PropTypes.number.isRequired,
  onClickLeft: PropTypes.func.isRequired,
  onClickRight: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
  sliderButtonClassName: PropTypes.string,
};

SliderControls.defaultProps = {
  sliderButtonClassName: null,
};

export default SliderControls;
